module.exports = __webpack_public_path__ + "static/media/Decisions_Step1_Image13.254bcd80.jpg";